import { ReferenceType } from '../../../../common/enums/ReferenceType';
import { IReferenceCandidateForm } from '../../../../common/models/reference/IReferenceCandidateForm';
import { IRefReqCounters } from '../../../../common/models/referenceRequest/IRefReqCounters';

export const refRequestData: {
  references: IReferenceCandidateForm[];
  refCounters: IRefReqCounters;
  currentReference: IReferenceCandidateForm;
} = {
  references: [],
  refCounters: {
    totalCount: 3,
    managersCount: 0,
    peersCount: 0,
    subordinatesCount: 2,
    educatorsCount: 0,
    othersCount: 0
  },
  currentReference: {
    id: '1',
    contatId: '1',
    type: ReferenceType.Subordinate,
    firstName: 'Reference',
    lastName: '1',
    phoneNumber: null,
    email: null,
    workInCompany: '',
    workStartDate: new Date(),
    workEndDate: null
  }
};
